import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@shared/services/session.service';
import { of, switchMap, withLatestFrom } from 'rxjs';

export function mainRouteGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot) => {
    const sessionService: SessionService = inject(SessionService);
    const router: Router = inject(Router);

    return sessionService.getUserType().pipe(
      withLatestFrom(
        sessionService.getSessionPermissions(),
        sessionService.getSession(),
        sessionService.getAccessRestrictedWithoutAgreement(),
      ),
      switchMap(([userType, permissions, session, accessRestrictedWithoutAgreement]) => {
        if ((session!.mfa_setting!.enforced && !session!.mfa_setting!.active) || accessRestrictedWithoutAgreement)
          return of(router.parseUrl('/settings/profile'));
        switch (route.routeConfig?.path) {
          case 'orders-and-opportunities':
          case 'renewals': {
            if (permissions?.includes('orders_and_quotes_view') || permissions?.includes('orders_and_quotes_view')) {
              return of(true);
            }
            break;
          }
          case 'cart': {
            if (
              permissions?.includes('orders_create') ||
              permissions?.includes('quotes_create') ||
              permissions?.includes('nfr_subscriptions_create') ||
              permissions?.includes('trial_subscriptions_create')
            ) {
              return of(true);
            }
            break;
          }
          case 'customers': {
            if (permissions?.includes('customers_view')) {
              return of(true);
            }
            break;
          }
          case 'opportunities': {
            if (permissions?.includes('orders_and_quotes_view')) {
              return of(true);
            }
            break;
          }
          case 'promotions': {
            if (userType == 'intranet' && permissions?.includes('promotions_view')) {
              return of(true);
            }
            break;
          }
          case 'partner-suite': {
            if (userType != 'intranet' && permissions?.includes('partner_details_edit')) {
              return of(true);
            }
            break;
          }
          case 'my-account': {
            if (userType != 'intranet' && permissions?.includes('account_view')) {
              return of(true);
            }
            break;
          }
          case 'accounts': {
            if (userType == 'intranet' && permissions?.includes('account_view')) {
              return of(true);
            }
            break;
          }
          case 'partner-applications': {
            if (userType == 'intranet' && permissions?.includes('partner_applications_review')) {
              return of(true);
            }
            break;
          }
          case 'offerings': {
            if (userType == 'intranet' && permissions?.includes('offerings_admin')) {
              return of(true);
            }
            break;
          }
          case 'users': {
            if (permissions?.includes('users_view')) {
              return of(true);
            }
            break;
          }
          case 'support': {
            if (userType != 'intranet') {
              return of(true);
            }
            break;
          }
        }
        return of(router.parseUrl('/'));
      }),
    );
  };
}
